// extracted by mini-css-extract-plugin
module.exports = {"main":"Auth_main__8SZOP","logo":"Auth_logo__17Ci2","auth":"Auth_auth__1v5L7","switch":"Auth_switch__1CrHb","authBack":"Auth_authBack__1gRC9"};